import React from "react"
import PropTypes from "prop-types"
import AppBar from "material-ui/AppBar"
import TextField from "material-ui/TextField"
import Checkbox from "material-ui/Checkbox"
import Clear from "../../../components/misc/Clear"
import strings from "../../../localization/strings"

const actionBarStyles = {
    display: "block",
    height: 60
}
const headerBarStyles = {
    display: "block",
    height: 60
}
const editActionStylea = {
    display: "inline"
}

const propTypes = {
    selectionCount: PropTypes.number,
    itemName: PropTypes.string,
    itemNamePlural: PropTypes.string,
    toggleAllSelect: PropTypes.func,
    onDeleteSelected: PropTypes.func,
    allSelected: PropTypes.bool
}

export default class FaceSpaceListActionBar extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.getActionsBarVisibility = this.getActionsBarVisibility.bind(this)
        this.getHeaderBarVisibility = this.getHeaderBarVisibility.bind(this)
        this.getEditActionVisibility = this.getEditActionVisibility.bind(this)
        this.onSelectClick = this.onSelectClick.bind(this)
        this.onDelete = this.onDelete.bind(this)

        const showActions = props.selectionCount > 0

        this.state = {
            actionsVisibility: this.getActionsBarVisibility(this.props),
            headerVisibility: this.getHeaderBarVisibility(this.props),
            itemName: this.props.itemName,
            itemNamePlural: this.props.itemNamePlural,
            editActionVisibility: this.getEditActionVisibility(this.props)
        }
    }

    getActionsBarVisibility(props) {
        const showActions = props.selectionCount > 0
        return showActions
    }

    getHeaderBarVisibility(props) {
        const showActions = props.selectionCount > 0
        return !showActions
    }

    getEditActionVisibility(props) {
        const showEdit = props.selectionCount === 1
        return showEdit
    }

    onSelectClick() {
        this.props.toggleAllSelect()
    }

    onDelete(e) {
        e.preventDefault()
        this.props.onDeleteSelected()
    }

    render() {
        return (
            <div className="FaceSpaceListActionBar">
                <div>
                    <div
                        style={{
                            background: "#cccccc",
                            padding: 20,
                            paddingLeft: 35
                        }}
                    >
                        <Checkbox
                            data-intercom-target={"menu-Employees-FaceSpaces-CheckAll"}
                            checked={this.props.allSelected}
                            onCheck={this.onSelectClick}
                            label={strings.formatString(strings.x_Selected, this.props.selectionCount)}
                            labelStyle={{ fontSize: 25, marginLeft: 10 }}
                        />
                        <div
                            style={{
                                position: "absolute",
                                top: 20,
                                right: 25,
                                zIndex: 100
                            }}
                            onClick={(e) => this.onDelete(e)}
                        >
                            {this.props.selectionCount > 0 && <i className="fa fa-trash itemActionButton" style={{ fontSize: 25, marginLeft: 20 }} />}
                        </div>

                        <Clear />
                    </div>
                </div>
            </div>
        )
    }
}

FaceSpaceListActionBar.propTypes = propTypes
